import React from 'react';
import { Container, Typography, Box } from '@mui/material';

export default function SchoolManagement() {
  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Gestion des écoles
        </Typography>
      </Box>
    </Container>
  );
}
